import { Injectable } from '@angular/core';
import { CourseSummaryComponent } from '../../components/course-summary/course-summary.component';
import { AvailableStepsInNavigationBar, NavigationBarItem, RouteIds, Step } from '../../types';
import { BaseStepDefinitionStrategy } from './base-step-definition.strategy';
import { StepDefinitionStrategy } from './step-definition.strategy';
import { customizeQuoteStepNavigationBarItem } from '../../utils';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class ExtrasStepDefinitionService extends BaseStepDefinitionStrategy implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.extras,
    title: $localize`Personalize your stay`,
    floatingPanel: {
      component: CourseSummaryComponent,
      position: 'title',
    },
    nextButton: $localize`Next`,
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Extras,
    nextStep: () => RouteIds.applicant,
  };

  getStepDefinition(activeFlow: Flow) {
    return {
      ...this.stepDefinition,
      navigationBarItems: this.getNavigationBarItems(activeFlow),
    };
  }

  fillNavigationBarItemsProperties(
    baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
    activeFlow: Flow,
  ): Record<AvailableStepsInNavigationBar, NavigationBarItem> {
    const filledNavigationBarItems = { ...baseNavigationBarItems };

    // Fill extra properties
    filledNavigationBarItems[RouteIds.course] = {
      ...filledNavigationBarItems[RouteIds.course],
      icon: 'check',
    };
    filledNavigationBarItems[RouteIds.applicant] = {
      ...filledNavigationBarItems[RouteIds.applicant],
      disabled: true,
    };

    return {
      ...filledNavigationBarItems,
      ...customizeQuoteStepNavigationBarItem(activeFlow, filledNavigationBarItems),
    };
  }
}
